import { StyleSheet } from "react-native";

import type { UiTheme } from "../../theme";

// PE-22 K3.2 — the load-axis selector's own styles, same makeXStyles(theme)
// recipe as coveragePanelStyles.ts. Token-only: no hex, every colour/spacing
// value comes off `theme`.
export function makeLoadAxisSelectorStyles(theme: UiTheme) {
  const { palette: p, spacing: s, typography: t } = theme;
  return StyleSheet.create({
    line: { marginTop: s.s3, gap: s.s2 },
    label: {
      color: p.ink3,
      fontSize: t.sizes.xs,
      fontWeight: "700",
      textTransform: "uppercase",
      letterSpacing: 0.4,
    },
    row: { flexDirection: "row", flexWrap: "wrap", gap: s.s2 },
  });
}
